// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 672) return "static/js/p-shared-672.e53ee985.chunk.js";
	if (chunkId === 60) return "static/js/p-archive.d3e777fe.chunk.js";
	if (chunkId === 781) return "static/js/p-dossier.c2442e1f.chunk.js";
	if (chunkId === 301) return "static/js/p-bookmarks.d1c20bcf.chunk.js";
	if (chunkId === 162) return "static/js/p-shared-162.f2455b4b.chunk.js";
	if (chunkId === 409) return "static/js/p-threads.2e5a195f.chunk.js";
	if (chunkId === 748) return "static/js/p-thread-detail.b2e46912.chunk.js";
	if (chunkId === 390) return "static/js/p-messages.5b3b97f8.chunk.js";
	if (chunkId === 565) return "static/js/p-trending.81aa05e4.chunk.js";
	if (chunkId === 81) return "static/js/p-profile.aa9cf86b.chunk.js";
	if (chunkId === 853) return "static/js/p-shared-853.72a2c5d1.chunk.js";
	if (chunkId === 601) return "static/js/p-public-profile.74199a0b.chunk.js";
	if (chunkId === 810) return "static/js/p-receipt.4549295b.chunk.js";
	if (chunkId === 794) return "static/js/p-warroom-lobby.6f8fd8b9.chunk.js";
	if (chunkId === 369) return "static/js/p-shared-369.6ac8e260.chunk.js";
	if (chunkId === 466) return "static/js/p-shared-466.ef0578ad.chunk.js";
	if (chunkId === 621) return "static/js/p-warroom.572a7714.chunk.js";
	if (chunkId === 326) return "static/js/p-warroom-snap.dd09ca4c.chunk.js";
	if (chunkId === 543) return "static/js/p-cards.a0212e6a.chunk.js";
	if (chunkId === 573) return "static/js/p-awakening.c2c5555a.chunk.js";
	if (chunkId === 111) return "static/js/p-ascension.86cbb5b0.chunk.js";
	if (chunkId === 277) return "static/js/p-stitches.99e5a87f.chunk.js";
	if (chunkId === 397) return "static/js/p-stitch-detail.76bf6756.chunk.js";
	if (chunkId === 443) return "static/js/p-stitch-builder.4385d74d.chunk.js";
	if (chunkId === 92) return "static/js/p-theme-studio.6840574e.chunk.js";
	if (chunkId === 551) return "static/js/p-share-theme.ba3b973b.chunk.js";
	if (chunkId === 825) return "static/js/p-sigils.8d52fda0.chunk.js";
	if (chunkId === 406) return "static/js/p-bento.954c16b6.chunk.js";
	if (chunkId === 401) return "static/js/p-meme-studio.e48929a8.chunk.js";
	if (chunkId === 303) return "static/js/p-meme-gallery.435f6c63.chunk.js";
	if (chunkId === 139) return "static/js/p-draws.1d36560f.chunk.js";
	if (chunkId === 13) return "static/js/p-postcard-build.2df6920e.chunk.js";
	if (chunkId === 956) return "static/js/p-postcard-view.8d4e6180.chunk.js";
	if (chunkId === 891) return "static/js/p-forge.d13fad2e.chunk.js";
	if (chunkId === 979) return "static/js/p-forge-disc.b847b8db.chunk.js";
	if (chunkId === 152) return "static/js/p-learn.742d116c.chunk.js";
	if (chunkId === 992) return "static/js/p-states.8d0e98cb.chunk.js";
	if (chunkId === 583) return "static/js/p-shared-583.cc2bf4f0.chunk.js";
	if (chunkId === 330) return "static/js/p-stickers.ca888442.chunk.js";
	if (chunkId === 391) return "static/js/p-shared-391.b3149b45.chunk.js";
	if (chunkId === 72) return "static/js/p-tune.61db3077.chunk.js";
	if (chunkId === 591) return "static/js/p-watch.62da6912.chunk.js";
	// return url for filenames based on template
	return undefined;
};